import { Divider, IconButton, Typography } from '@mui/material';
import { Image } from 'react-native';
import { useCallback } from 'react';
import { AccessLevel } from '../models/enums/AccessLevel';
import { navigationStore } from '../app/stores/Navigation';

interface ProfileIconProps {
    isAuthenticated: boolean;
    firstName: string;
    role: AccessLevel;
    darkMode: boolean;
}

export const ProfileIcon = ({ isAuthenticated, firstName, darkMode }: Omit<ProfileIconProps, 'onClick'>) => {
    const { updateProfileDrawerOpen } = navigationStore((state) => state);

    const handleClick = useCallback(() => {
        // Always open profile drawer - it handles both auth and unauth states
        updateProfileDrawerOpen(true);
    }, [updateProfileDrawerOpen]);

    return (
        <IconButton
            sx={{
                alignSelf: "center",
                justifyContent: "center",
                borderRadius: 8,
                backgroundColor: darkMode ? "#333333" : "#f1f1f1",
                paddingX: 2,
                color: darkMode ? "white" : "black"
            }}
            onClick={handleClick}
        >
            <Image
                style={{
                    resizeMode: "contain",
                    width: 20,
                    height: 20,
                    tintColor: darkMode ? "white" : "black",
                }}
                source={require("../assets/profile-icon.png")}
            />
            {
                isAuthenticated && firstName &&
                <>
                    <Divider
                        color={darkMode ? "white" : "black"}
                        orientation="vertical"
                        style={{
                            width: 2,
                            marginLeft: 8,
                            marginRight: 12,
                            height: 16,
                            alignSelf: "center",
                        }}
                    />
                    <Typography
                        variant="body2"
                        sx={{
                            fontSize: 12,
                            fontWeight: "600",
                            fontFamily: "primaryFont",
                            letterSpacing: 0.5,
                            color: darkMode ? "white" : "black"
                        }}
                    >
                        {`${firstName}`}
                    </Typography>
                </>
            }
            {
                !isAuthenticated &&
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: 12,
                        fontWeight: "600",
                        fontFamily: "primaryFont",
                        letterSpacing: 0.5,
                        marginLeft: "8px",
                        color: darkMode ? "white" : "black"
                    }}
                >
                    {`Sign In`}
                </Typography>
            }
        </IconButton>
    )
}
